exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  margin: 5px 10px;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: .8rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/footer/footer/footer.component.scss
// module id = ../../../../../src/app/pages/shared/footer/footer/footer.component.scss
// module chunks = main